import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_simpleHeader = _resolveComponent("simpleHeader");

  const _component_router_view = _resolveComponent("router-view");

  const _component_simpleFooter = _resolveComponent("simpleFooter");

  return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createVNode(_component_simpleHeader, null, null, 512), [[_vShow, _ctx.isShowBar]]), _createVNode(_component_router_view), _withDirectives(_createVNode(_component_simpleFooter, null, null, 512), [[_vShow, _ctx.isShowBar]])], 64);
}